import EmptyState from "./EmptyState";
import ErrorState from "./ErrorState";
import Spinner from "./Spinner";

export default function AsyncContent({ loading, error, empty = false, onRetry, emptyMessage = "اطلاعات مورد نظر یافت نشد", children, className = "min-h-[180px]" }) {
  if (loading) return <div role="status" aria-label="در حال بارگذاری" className={`flex items-center justify-center text-[#8080804d] ${className}`}><Spinner /></div>;
  if (error) return <ErrorState message={error} onRetry={onRetry} className={className} />;
  if (empty) return <EmptyState message={emptyMessage} className={className} />;
  return children;
}
